'use client';

import { usePathname, useRouter } from '@/i18n/routing';
import { useLocale } from 'next-intl';
import { rememberLangCookie } from '@/components/cabinet/locale-live';
import { KBareButton } from '@scriptera/ui/kit';

interface LocaleSwitchProps {
  // compact — кнопка для плавающей шапки: показывает текущую локаль (RU/EN).
  compact?: boolean;
  className?: string;
}

// Переключатель языка: ведёт на тот же путь в другой локали (next-intl routing).
export function LocaleSwitch({ compact, className }: LocaleSwitchProps = {}) {
  const locale = useLocale();
  const pathname = usePathname();
  const router = useRouter();
  const other = locale === 'ru' ? 'en' : 'ru';

  return (
    <KBareButton
      onClick={() => {
        // Память браузера для невошедших: выбранный язык — в куку, следующий заход
        // на страницу без префикса откроется сразу на нём (приоритеты 2026-07-23).
        rememberLangCookie(other);
        router.replace(pathname, { locale: other });
      }}
      title={`Switch to ${other.toUpperCase()}`}
      className={
        className ??
        'rounded-md border border-line2 bg-surf px-3 py-2 text-sm font-bold uppercase text-ink shadow-sm transition hover:border-accent'
      }
    >
      {(compact ? locale : other).toUpperCase()}
    </KBareButton>
  );
}
